import React from 'react';
import { styles } from './ImageGrid.css';
import { PossiblyResponsiveValue, useResponsiveValue } from '../hooks/useResponsiveValue';

export type ImageGridProps = {
  images: React.ReactNode;
  numColumns?: PossiblyResponsiveValue<number>;
  numElements?: PossiblyResponsiveValue<number | null>;
};

export const ImageGrid = ({
  images,
  numColumns: numColumnsProp = { xs: 3, md: 5 },
  numElements: numElementsProp = { xs: 9, md: null },
}: ImageGridProps) => {
  const numColumns = useResponsiveValue(numColumnsProp);
  const numElements = useResponsiveValue<number | null>(numElementsProp);
  const _images = numElements ? React.Children.toArray(images)?.slice(0, numElements) : images;

  return (
    <div
      className={styles.imageGrid}
      style={{ gridTemplateColumns: numColumns ? `repeat(${numColumns}, 1fr)` : undefined }}
    >
      {_images}
    </div>
  );
};
